import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TracingToursActionCreators } from 'app/reducers/TracingToursRedux'

const useTracingTour = tracingTourName => {
  const dispatch = useDispatch()
  const { isOpen, hasViewed } = useSelector(
    state => state.tracingTours[tracingTourName]
  ) || {}

  useEffect(() => {
    dispatch(TracingToursActionCreators.registerTour(tracingTourName))
  }, [tracingTourName])

  const toggleOpen = isOpen => {
    dispatch(TracingToursActionCreators.toggleOpen(tracingTourName, isOpen))
  }

  return [{ isOpen, hasViewed }, toggleOpen]
}

export default useTracingTour
